/*  ========================================================================
    # Components - Services Illustration - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import ServicesIllustration from './ServicesIllustration';

const containers = document.querySelectorAll('div[data-react-app="ServicesIllustration"]');

for (let i = 0; i < containers.length; i++) {
  createRoot(containers[i]).render(<ServicesIllustration />);
}
